module.exports = __webpack_public_path__ + "static/colouring_in_augustus_thumb_3-0dd238132665ebf5052cbe9a2e6c16ec.jpg";